export const mediaQueryOptions = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
};
export const breakpoints = {
  down: size => `(max-width:${mediaQueryOptions[size] - 1}px)`,
  up: size => `(min-width:${mediaQueryOptions[size]}px)`,
  between: (min, max) => `(min-width:${mediaQueryOptions[min]}px) and (max-width:${mediaQueryOptions[max] - 1}px)`
};